const border_colors = '#553A4D'

export const proyale_principal = {
  body_background_image_url: 'proyaleaugmentee/FondProyale.webp',

  header_background_url: 'proyaleaugmentee/EnteteProyaleNew.webp',
  header_height: 207,
  logo_hidden: true,
  header_full_height: true,

  card_background_image_url: 'proyaleaugmentee/FondAubergine.webp',
  card_background_image_repeat: 'contain',

  title_font: 'Poppins',
  subtitle_font: 'Poppins',
  subtitle_color: '#9F5B67',

  text_font: 'Acumin Variable Concept',
  text_size: 16,

  token_url: 'proyaleaugmentee/PastilleStationOrdinaire.png',
  number_color: '#FFFFFF',

  button_color: '#476C6E',
  photobooth_button_color: '#476C6E',
  button_radius: 50,

  separator_color: '#553A4D',
  separator_height: 4,

  framed_background: border_colors,
  ra_border_color: border_colors,
  ra_border_radius: '15px',
}

export const proyale_principal_en = {
  body_background_image_url: 'proyaleaugmentee/FondProyale.webp',

  header_background_url: 'proyaleaugmentee/EnteteEn.webp',
  header_height: 207,
  logo_hidden: true,
  header_full_height: true,

  card_background_image_url: 'proyaleaugmentee/FondAubergine.webp',
  card_background_image_repeat: 'contain',

  title_font: 'Poppins',
  subtitle_font: 'Poppins',
  subtitle_color: '#9F5B67',

  text_font: 'Acumin Variable Concept',
  text_size: 16,

  token_url: 'proyaleaugmentee/PastilleStationOrdinaire.png',
  number_color: '#FFFFFF',

  button_color: '#476C6E',
  photobooth_button_color: '#476C6E',
  button_radius: 50,

  separator_color: '#553A4D',
  separator_height: 4,

  framed_background: border_colors,
  ra_border_color: border_colors,
  ra_border_radius: '15px',
}

export const proyale_principal_no_credits = {
  body_background_image_url: 'proyaleaugmentee/FondProyale.webp',

  header_background_url: 'proyaleaugmentee/EnteteProyale.webp',
  header_height: 207,
  logo_hidden: true,
  header_full_height: true,

  card_background_image_url: 'proyaleaugmentee/FondAubergine.webp',
  card_background_image_repeat: 'contain',

  title_font: 'Poppins',
  subtitle_font: 'Poppins',
  subtitle_color: '#9F5B67',

  text_font: 'Acumin Variable Concept',
  text_size: 16,

  token_url: 'proyaleaugmentee/PastilleStationOrdinaire.png',
  number_color: '#FFFFFF',

  button_color: '#476C6E',
  photobooth_button_color: '#476C6E',
  button_radius: 50,

  separator_color: '#553A4D',
  separator_height: 4,

  framed_background: border_colors,
  ra_border_color: border_colors,
  ra_border_radius: '15px',
}

export const proyale_principal_no_number = {
  body_background_image_url: 'proyaleaugmentee/FondProyale.webp',

  number_hidden: true,

  header_background_url: 'proyaleaugmentee/EnteteProyaleNew.webp',
  header_height: 207,
  logo_hidden: true,
  header_full_height: true,

  card_background_image_url: 'proyaleaugmentee/FondAubergine.webp',
  card_background_image_repeat: 'contain',

  title_font: 'Poppins',
  subtitle_font: 'Poppins',
  subtitle_color: '#9F5B67',

  text_font: 'Acumin Variable Concept',
  text_size: 16,

  token_url: 'proyaleaugmentee/PastilleStationOrdinaire.png',
  number_color: '#FFFFFF',

  button_color: '#476C6E',
  photobooth_button_color: '#476C6E',
  button_radius: 50,

  separator_color: '#553A4D',
  separator_height: 4,

  framed_background: border_colors,
  ra_border_color: border_colors,
  ra_border_radius: '15px',
}

export const proyale_principal_no_number_en = {
  body_background_image_url: 'proyaleaugmentee/FondProyale.webp',

  number_hidden: true,

  header_background_url: 'proyaleaugmentee/EnteteEn.webp',
  header_height: 207,
  logo_hidden: true,
  header_full_height: true,

  card_background_image_url: 'proyaleaugmentee/FondAubergine.webp',
  card_background_image_repeat: 'contain',

  title_font: 'Poppins',
  subtitle_font: 'Poppins',
  subtitle_color: '#9F5B67',

  text_font: 'Acumin Variable Concept',
  text_size: 16,

  token_url: 'proyaleaugmentee/PastilleStationOrdinaire.png',
  number_color: '#FFFFFF',

  button_color: '#476C6E',
  photobooth_button_color: '#476C6E',
  button_radius: 50,

  separator_color: '#553A4D',
  separator_height: 4,

  framed_background: border_colors,
  ra_border_color: border_colors,
  ra_border_radius: '15px',
}

export const proyale_secondaire = {
  body_background_image_url: 'proyaleaugmentee/FondProyale.webp',

  header_background_url: 'proyaleaugmentee/EnteteProyaleNew.webp',
  header_height: 207,
  logo_hidden: true,
  header_full_height: true,

  card_background_image_url: 'proyaleaugmentee/FondAubergine.webp',
  card_background_image_repeat: 'contain',

  title_font: 'Poppins',

  subtitle_font: 'Poppins',
  subtitle_color: '#9F5B67',

  text_font: 'Acumin Variable Concept',
  text_size: 16,

  token_url: 'proyaleaugmentee/PastilleStationPeche.png',
  number_hidden: true,
  number_color: '#FFFFFF',

  button_color: '#476C6E',
  photobooth_button_color: '#476C6E',
  button_radius: 50,

  separator_color: '#553A4D',
  separator_height: 4,

  framed_background: border_colors,
  ra_border_color: border_colors,
  ra_border_radius: '15px',
}

export const proyale_secondaire_en = {
  body_background_image_url: 'proyaleaugmentee/FondProyale.webp',

  header_background_url: 'proyaleaugmentee/EnteteEn.webp',
  header_height: 207,
  logo_hidden: true,
  header_full_height: true,

  card_background_image_url: 'proyaleaugmentee/FondAubergine.webp',
  card_background_image_repeat: 'contain',

  title_font: 'Poppins',

  subtitle_font: 'Poppins',
  subtitle_color: '#9F5B67',

  text_font: 'Acumin Variable Concept',
  text_size: 16,

  token_url: 'proyaleaugmentee/PastilleStationPeche.png',
  number_hidden: true,
  number_color: '#FFFFFF',

  button_color: '#476C6E',
  photobooth_button_color: '#476C6E',
  button_radius: 50,

  separator_color: '#553A4D',
  separator_height: 4,

  framed_background: border_colors,
  ra_border_color: border_colors,
  ra_border_radius: '15px',
}

export const proyale_beige = {
  body_background_image_url: 'proyaleaugmentee/FondProyale.webp',

  header_background_url: 'proyaleaugmentee/EnteteProyale.webp',
  header_height: 207,
  logo_hidden: true,
  header_full_height: true,

  card_background_image_url: 'proyaleaugmentee/FondAubergine.webp',
  card_background_image_repeat: 'contain',

  title_font: 'Poppins',

  subtitle_font: 'Poppins',
  subtitle_color: '#9F5B67',

  text_font: 'Acumin Variable Concept',
  text_size: 16,

  token_url: 'proyaleaugmentee/PastilleStationBeige.png',
  number_hidden: true,
  number_color: '#FFFFFF',

  button_color: '#476C6E',
  photobooth_button_color: '#476C6E',
  button_radius: 50,

  separator_color: '#553A4D',
  separator_height: 4,

  framed_background: border_colors,
  ra_border_color: border_colors,
  ra_border_radius: '15px',
}

export const proyale_aubergine = {
  body_background_image_url: 'proyaleaugmentee/FondProyale.webp',

  header_background_url: 'proyaleaugmentee/EnteteProyale.webp',
  header_height: 207,
  logo_hidden: true,
  header_full_height: true,

  card_background_image_url: 'proyaleaugmentee/FondAubergine.webp',
  card_background_image_repeat: 'contain',

  title_font: 'Poppins',

  subtitle_font: 'Poppins',
  subtitle_color: '#9F5B67',

  text_font: 'Acumin Variable Concept',
  text_size: 16,

  token_url: 'proyaleaugmentee/PastilleStationAubergine.png',
  number_hidden: true,
  number_color: '#FFFFFF',

  button_color: '#476C6E',
  photobooth_button_color: '#476C6E',
  button_radius: 50,

  separator_color: '#553A4D',
  separator_height: 4,

  framed_background: border_colors,
  ra_border_color: border_colors,
  ra_border_radius: '15px',
}

export const proyale_aubergine_jeu = {
  body_background_image_url: 'proyaleaugmentee/FondProyale.webp',

  header_background_url: 'proyaleaugmentee/EnteteProyaleJeu.webp',
  header_height: 207,
  logo_hidden: true,
  header_full_height: true,

  card_background_image_url: 'proyaleaugmentee/FondAubergine.webp',
  card_background_image_repeat: 'contain',

  title_font: 'Poppins',

  subtitle_font: 'Poppins',
  subtitle_color: '#9F5B67',

  text_font: 'Acumin Variable Concept',
  text_size: 16,

  token_url: 'proyaleaugmentee/PastilleStationAubergine.png',
  number_hidden: true,
  number_color: '#FFFFFF',

  button_color: '#476C6E',
  photobooth_button_color: '#476C6E',
  button_radius: 50,

  separator_color: '#553A4D',
  separator_height: 4,

  framed_background: border_colors,
  ra_border_color: border_colors,
  ra_border_radius: '15px',
}

export const proyale_aubergine_en = {
  body_background_image_url: 'proyaleaugmentee/FondProyale.webp',

  header_background_url: 'proyaleaugmentee/EnteteJeuEn.webp',
  header_height: 207,
  logo_hidden: true,
  header_full_height: true,

  card_background_image_url: 'proyaleaugmentee/FondAubergine.webp',
  card_background_image_repeat: 'contain',

  title_font: 'Poppins',

  subtitle_font: 'Poppins',
  subtitle_color: '#9F5B67',

  text_font: 'Acumin Variable Concept',
  text_size: 16,

  token_url: 'proyaleaugmentee/PastilleStationAubergine.png',
  number_hidden: true,
  number_color: '#FFFFFF',

  button_color: '#476C6E',
  photobooth_button_color: '#476C6E',
  button_radius: 50,

  separator_color: '#553A4D',
  separator_height: 4,

  framed_background: border_colors,
  ra_border_color: border_colors,
  ra_border_radius: '15px',
}